import type {TeacherRole} from '@freckle/educator-entities/ts/common/helpers/teacher-role'
import {TeacherRoles} from '@freckle/educator-entities/ts/common/helpers/teacher-role'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {OptionType} from '@freckle/educator-materials/ts/logic/dropdown'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {roleDropdownStyle} from './role-dropdown.module.scss'

type RoleDropdownT = {
  initRole: TeacherRole | undefined | null
  routeFn: (value?: string | null) => void
}

export function RoleDropdown(props: RoleDropdownT) {
  const {initRole, routeFn} = props
  const {t} = useSafeTranslation()
  const roleToValue = (role?: TeacherRole | null): OptionType<TeacherRole | undefined | null> =>
    role !== undefined && role !== null
      ? {label: TeacherRoles.forDisplay(role), value: role}
      : {label: t('MANAGE_TEACHERS_TEACHER_TAB_TEACHER_TABLE_ALL_ROLES_OPTION'), value: null}

  const selectedRole = roleToValue(initRole)
  const teacherRoles = TeacherRoles.all().map(roleToValue)

  const collection = [roleToValue(null), ...teacherRoles]
  return (
    <div id="dashboard-teachers-role-selector" className={roleDropdownStyle}>
      <Dropdown<TeacherRole | undefined | null>
        labelText={t('MANAGE_TEACHERS_TEACHER_TAB_TEACHER_TABLE_ROLE_HEADER')}
        value={selectedRole}
        options={flatOptions(collection)}
        handleChange={input => {
          if (input === null) return
          routeFn(input.value)
        }}
        // for some reason the role dropdown doesn't work in the table
        // this fixes it so it displays, if you're revisiting this
        // see if the issue is resolved and this no longer needs to be here
        portalTarget={document.body}
      />
    </div>
  )
}
